import { IUserFirstAccessStep } from '@flows/public/pages/UserFirstAccess/userFirstAccessSteps';

import { UserPassword } from '.';

export const UserPasswordStep: IUserFirstAccessStep = {
  name: 'Definição de senha',
  step: () => <UserPassword />,
};
